export enum AttachmentType {
	File	= 0,
	Link	= 1,
}
